<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Raporty wolontariuszy</h1>
		</v-card-title>
		<div v-if="loaded">
			<div v-if="!projectMetadata.isVolunteerParticipation">
				<h3 class="ml-4 mt-4">Udział wolontariuszy nie jest przewidziany</h3>
			</div>
			<div v-else-if="!reportGenerated">
				<h3 class="ml-4 mt-4">Żeby raporty wolontariuszy zostały wygenerowane, musi zostać podpisana umowa</h3>
			</div>
			<div v-else>
				<v-card style="padding: 24px; box-shadow: none;">
					<template v-if="!reports.length">
						<h3>Brak wygenerowanych raportów</h3>
					</template>
					<template v-else>
						<v-list>
							<template v-for="report in reports">
								<v-list-tile avatar :key="report.id">
									<v-list-tile-avatar>
										<v-icon large color="primary">description</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="report.fullName"/>
										<v-list-tile-sub-title v-html="report.reportDate"/>
										<span>
											<v-list-tile-action-text v-html="getStatusMessage(report)"/>
											<span v-if="report.status === 'REVISION'" class="ml-1">
												<v-tooltip top>
													<template v-slot:activator="{ on }">
														<v-icon size="16" color="blue" dark
															v-on="on">info_outline</v-icon>
													</template>
													<span>{{report.detailedCorrectionCause}}</span>
												</v-tooltip>
											</span>
										</span>
									</v-list-tile-content>
									<v-list-tile-action>
										<egranty-icon-button icon="build" color="primary" label="Oddaj do poprawek"
											:disabled="disableSubmitForCorrectionsButton(report)"
											@click="openCorrectionDialog(report.id)"/>
									</v-list-tile-action>
									<v-list-tile-action>
										<egranty-icon-button icon="description" color="primary"
											label="Podgląd" 
											@click="showReportForm(report)"/>
									</v-list-tile-action>
								</v-list-tile>
							</template>
						</v-list>
					</template>
				</v-card>
			</div>
		</div>
		<v-container fluid>
		<v-layout><h3>Uwagi</h3></v-layout>
				<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.volunteerRemarks"
						browser-autocomplete="off" aria-label="correspondence remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectVolunteerRemarks">Zapisz</v-btn>
		</v-container>
		<v-dialog v-model="correctionData.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Przekazanie raportu do poprawek</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="correctionCause"
						data-vv-as="Powód przekazania do poprawek"
						label="Powód przekazania do poprawek"
						:error-messages="vErrors.collect('correctionCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="correctionCause"
						aria-label="correction cause">
					</v-text-field>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="detailedCorrectionCause"
						data-vv-as="Opis szczegółowy"
						label="Opis szczegółowy"
						v-model="detailedCorrectionCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						v-validate="'required'"
						aria-label="detailed correction cause">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correctionCause !== '' && detailedCorrectionCause !== ''"
						color="blue darken-1"
						flat
						@click="sendForCorrection">
						Wyślij
					</v-btn>
					<v-btn
						color="blue"
						@click="correctionData.dialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {Project} from "../../../api/generated/Project";
	import {VolunteerReport} from "../../../api/generated/VolunteerReport";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "ProjectVolunteerReportsView",
		components: {EgrantyIconButton},
		data() {
			return {
				reports: [],
				projectMetadata: null,
				projectId: this.$route.params.projectId,
				correctionData: {
					dialog: false,
					reportId: null
				},
				correctionCause: '',
				detailedCorrectionCause: ''
			};
		},

		methods: {
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			disableSubmitForCorrectionsButton(report){
				return	((report.status !== 'FINISHED') || !this.hasProjectPanelSupervisorModificationAccess());
			},
			refresh() {
				Project.getBasicData(
					this,
					this.projectId,
					response => this.projectMetadata = response
				);
				VolunteerReport.getProjectReports(
					this,
					this.projectId,
					response => this.reports = response
				);
			},

			getStatusMessage (report) {
				switch (report.status) {
					case 'NEW':
						return "Nierozpoczęty";
					case 'STARTED':
						return "Rozpoczęty";
					case 'REVISION':
						return "Do poprawek: " + report.correctionCause;
					case 'FINISHED':
						return "Zakończony";
				}
			},

			showReportForm (item) {
				this.$router.push({
					path: "/app/project/" + this.projectId + "/volunteer-report/" + item.id,
				});
			},

			openCorrectionDialog (reportId) {
				this.correctionData.reportId = reportId;
				this.correctionData.dialog = true;
			},

			sendForCorrection () {
				VolunteerReport.putCorrection(this, this.prepareCorrectionForm(), successResponse => {
					this.correctionCause = '';
					this.detailedCorrectionCause = '';
					this.correctionData.reportId = null;
					this.correctionData.dialog = false;
					this.vErrors.clear();
					this.refresh();
					this.$messagesBus.$emit("success", "Raport został odesłany do poprawek", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się odesłać raportu do poprawek", errorResponse);
				});
			},

			prepareCorrectionForm () {
				return {
					id: this.correctionData.reportId,
					correctionCause: this.correctionCause,
					detailedCorrectionCause: this.detailedCorrectionCause
				};
			},

			onKeyDownEvent (evt) {
				if (this.correctionCause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) evt.preventDefault();
			},
			saveProjectVolunteerRemarks() {
				Project.putVolunteerRemarks(this, this.$route.params.projectId, {body: this.project.volunteerRemarks});
			}
		},

		computed: {
			reportGenerated() {
				return this.loaded && (this.projectMetadata.projectStatus === 'AGREEMENT_SIGNED');
			},

			loaded() {
				return this.projectMetadata !== null;
			}
		},

		mounted() {
			this.refresh();
		},
		props: {
			project: {
				type: Object
			},
		},
	};
</script>

<style scoped>

</style>